import {
  Box,
  HStack,
  Image,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { ThemeColor } from "../../theme/palette";
import { DRIP_TEXT_LABEL, DRIP_TEXT_SECONDARY } from "./dripStyles";

interface DripPageHeroProps {
  apy: number;
  apyLoading: boolean;
}

export const DripPageHero = ({ apy, apyLoading }: DripPageHeroProps) => (
  <VStack spacing={6} align="stretch" width="100%">
    <Box>
      <Text
        fontWeight="semibold"
        fontSize="5xl"
        color="white"
        lineHeight="1.1"
        letterSpacing="-0.02em"
      >
        Drip
      </Text>
      <Text fontSize="md" color={DRIP_TEXT_SECONDARY} mt={2} lineHeight="1.6">
        The easiest way to DCA into your favorite assets. Sit back and enjoy the flow to your wallet.
      </Text>
    </Box>

    <Box
      bg="rgba(95, 244, 244, 0.06)"
      borderRadius="xl"
      p={4}
      border="1px solid"
      borderColor="rgba(95, 244, 244, 0.25)"
    >
      <VStack spacing={3} align="start">
        <HStack
          px={2.5}
          py={1}
          borderRadius="full"
          bg="rgba(95, 244, 244, 0.1)"
          border="1px solid"
          borderColor="rgba(95, 244, 244, 0.3)"
          spacing={2}
        >
          <Image src="/logoMark.png" boxSize="18px" />
          <Text fontSize="xs" fontWeight="bold" color={ThemeColor.KAIROS} letterSpacing="0.04em">
            {apyLoading ? (
              <Spinner size="xs" />
            ) : (
              `Earn up to ${(apy * 2 * 100).toFixed(2)}% on your SOL`
            )}
          </Text>
        </HStack>
        <Text fontSize="sm" color="whiteAlpha.900" lineHeight="1.5">
          Drip into{" "}
          <Text as="span" fontWeight="semibold" color={ThemeColor.KAIROS}>
            KYROS
          </Text>{" "}
          and we will double your Drip amount.
        </Text>
        <Text fontSize="xs" color={DRIP_TEXT_LABEL}>
          Campaign applies until the allocation limit is reached.
        </Text>
      </VStack>
    </Box>
  </VStack>
);
